// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kLV-Q","content":"styles_content__0o5se","content__image":"styles_content__image__0otOH","content__title":"styles_content__title__0mT7Z"};